<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title">Telemetry</div>
            <div slot="content"></div>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '../components/app_layout.vue';

export default {
    components: {
        'app-layout': AppLayout
    },
    data: function () {
        return {
            loading: false
        }
    },
    mounted: function () {
        var dashboard = this.$app.getDefaultDashboard();
        if (dashboard !== undefined) {
            this.$router.push('/dashboards/' + dashboard.className + '?id=' + dashboard.id);
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?06b28774